var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIconRadius(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2538 1.06066C10.8396 0.474874 11.7893 0.474874 12.3751 1.06066C12.9609 1.64645 12.9609 2.59619 12.3751 3.18198L3.18273 12.3744C2.59694 12.9602 1.64719 12.9602 1.0614 12.3744C0.475619 11.7886 0.475618 10.8388 1.0614 10.253L10.2538 1.06066Z",
    fill: "#3E3D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.18175 1.06066C2.59597 0.474874 1.64622 0.474874 1.06043 1.06066C0.474647 1.64645 0.474647 2.59619 1.06043 3.18198L10.2528 12.3744C10.8386 12.9602 11.7884 12.9602 12.3741 12.3744C12.9599 11.7886 12.9599 10.8388 12.3741 10.253L3.18175 1.06066Z",
    fill: "#3E3D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconRadius);
export default __webpack_public_path__ + "static/media/closeIconRadius.0e338297ef17c594b82b0f5c3915d188.svg";
export { ForwardRef as ReactComponent };